import BrainSearchLandingPage from "@/brain-search/internal/BrainSearchLandingPage"
import BrainSearchPage from "@/brain-search/internal/BrainSearchPage"
import BrainSearchSidebar from "@/brain-search/internal/BrainSearchSidebar"
import { useBrainSearchWidth } from "@/brain-search/internal/utils/BrainSearchUtils"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { TestIDProps } from "@utils/typeUtils"
import classNames from "classnames"

function BrainSearchDrawerContent(props: TestIDProps) {
  const { testid = "BrainSearchDrawerContent" } = props
  const classes = useStyles()
  const drawer = useGlobalDrawer("brainSearch")
  const { isWide } = useBrainSearchWidth()

  return (
    <div className={classes.container}>
      {isWide && <BrainSearchSidebar />}
      <div
        className={classNames(classes.main, { [classes.bordered]: isWide })}
        data-testid={testid}
      >
        {drawer.params.drawerView === "history" ? (
          <BrainSearchSidebar fullView />
        ) : drawer.params.convId ? (
          <BrainSearchPage key={drawer.params.convId} />
        ) : (
          <BrainSearchLandingPage />
        )}
      </div>
    </div>
  )
}

const useStyles = makeUseStyles((theme) => ({
  container: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    overflow: "hidden",
  },
  main: {
    height: "100%",
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 0,
  },
  bordered: {
    borderLeft: `1px solid ${theme.palette.divider}`,
    borderTopLeftRadius: theme.measure.borderRadius.large,
    borderBottomLeftRadius: theme.measure.borderRadius.large,
    boxShadow: theme.palette.groovyDepths.boxShadow,
  },
}))

export default BrainSearchDrawerContent
